export const styles = {
  card: {
    marginBottom: '15px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  title: {
    fontSize: 16,
    color: '#333',
  },
  titleLink: {
    fontSize: 16,
    color: '#333',
    textDecoration: 'underline',
    fontWeight: 700,
    letterSpacing: 0.5,
  },
  date: {
    fontSize: 14,
    color: '#666',
  },
  button: {
    textTransform: 'none',
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  customDrawerPaper: {
    '&> .MuiDrawer-paper': {
      [`@media (min-width: ${992}px)`]: {
        width: '50%',
      },
    },
  },
}
export default styles
